/*
 * cwear-featured-product.js
 * Selector de variantes (talla/color) + compra directa. Cambia la
 * imagen según el color elegido y actualiza el precio mostrado, igual
 * que antes — pero ahora "Comprar ahora" y "Agregar al carrito" actúan
 * directo desde acá (decisión explícita del usuario: esta sección
 * existe para empujar la compra, no para mandar a la ficha completa).
 * "Comprar ahora" reusa el mismo flujo de cwear-cart-modal.js/
 * cwear-cart.js (vacía el carrito, agrega solo esta variante, va a
 * /checkout, respalda el resto en localStorage). Patrón portado de
 * cwear-pdp-main.js (carrusel de tallas/colores), simplificado: sin
 * galería, sin thumbnails, sin countdown. Escaneado por IIFE, scoped
 * por section.id, sin recarga de página en ningún punto (regla del
 * proyecto).
 */
(function () {
  'use strict';

  function scrollElementByX(el, amount) {
    if (!el || typeof amount !== 'number') return;
    el.scrollLeft = el.scrollLeft + amount;
  }

  /* Mueve SOLO el scroll horizontal del track (nunca el de la página) para
     traer el botón activo a la vista. `el.scrollIntoView()` no sirve acá:
     considera TODOS los contenedores con scroll en la cadena de ancestros,
     document incluido — en Home/Catálogo, donde esta sección queda más
     abajo en la página (a diferencia del PDP, donde ya está arriba de
     todo), terminaba saltando la página entera hasta Producto Destacado
     apenas cargaba, aunque el botón ya estuviera "cerca" dentro de su
     propio carrusel. */
  function scrollActiveIntoTrack(track, el) {
    if (!track || !el) return;
    var elLeft = el.offsetLeft;
    var elRight = elLeft + el.offsetWidth;
    var trackLeft = track.scrollLeft;
    var trackRight = trackLeft + track.clientWidth;
    if (elLeft < trackLeft) {
      track.scrollLeft = elLeft;
    } else if (elRight > trackRight) {
      track.scrollLeft = elRight - track.clientWidth;
    }
  }

  var sections = document.querySelectorAll('[id^="cwear-fp-config-"]');

  Array.prototype.forEach.call(sections, function (configEl) {
    var sectionId = configEl.id.replace('cwear-fp-config-', '');
    var config;
    var variants;

    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var variantsEl = document.getElementById('cwear-fp-variants-' + sectionId);
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var optionsWrap = document.getElementById('cwear-fp-options-' + sectionId);

    var buyNowBtn = document.getElementById('cwear-fp-buy-now-' + sectionId);
    var addToCartBtn = document.getElementById('cwear-fp-add-to-cart-' + sectionId);
    var section = buyNowBtn ? buyNowBtn.closest('.cwear-featured-product')
      : (optionsWrap ? optionsWrap.closest('.cwear-featured-product') : null);
    var errorEl = section ? section.querySelector('[data-fp-error]') : null;
    var priceEl = section ? section.querySelector('[data-fp-price]') : null;
    var imageEl = section ? section.querySelector('.cwear-featured-product__image-col img') : null;
    var mobileSourceEl = section ? section.querySelector('.cwear-featured-product__image-col source') : null;

    var currentSelections = {};

    if (imageEl) {
      imageEl.setAttribute('data-fp-image-src', imageEl.src);
    }

    /* ── "Comprar ahora" / "Agregar al carrito" — funcionan con o sin
       selector de opciones (producto de una sola variante) ── */

    function hasCompleteSelection() {
      if (!optionsWrap) return true;
      var names = config.optionNames || [];
      for (var i = 0; i < names.length; i++) {
        if (!currentSelections[names[i]]) return false;
      }
      return true;
    }

    function getCurrentVariant() {
      if (optionsWrap && config.optionNames && config.optionNames.length) {
        return findVariant(currentSelections);
      }
      return variants[0] || null;
    }

    function showActionError(message) {
      if (errorEl) errorEl.textContent = message;
    }

    function resolveVariantOrError() {
      if (!hasCompleteSelection()) {
        showActionError('Seleccioná color y talla');
        return null;
      }
      var variant = getCurrentVariant();
      if (!variant || !variant.available) {
        showActionError('Esa combinación no está disponible');
        return null;
      }
      showActionError('');
      return variant;
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cwear-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    function updateCartBubble() {
      return fetch('/?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections && sections['cart-icon-bubble']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc.querySelector('#cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); })
        .catch(function () {});
    }

    function handleAddToCart() {
      var variant = resolveVariantOrError();
      if (!variant || !addToCartBtn) return;

      var originalText = addToCartBtn.textContent;
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        })
        .then(function () { return updateCartBubble(); })
        .then(function () {
          try {
            document.dispatchEvent(new CustomEvent('cwear:cart:open'));
          } catch (e) { /* noop */ }
          addToCartBtn.disabled = false;
        })
        .catch(function (err) {
          console.warn('[cwear-featured-product] add to cart error:', err);
          showActionError('No se pudo agregar, intentá de nuevo');
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalText;
        });
    }

    /* "Comprar ahora": mismo flujo que cwear-cart-modal.js /
       cwear-cart.js — vacía el carrito dejando solo esta variante y va
       directo a /checkout. El resto se respalda en la MISMA clave de
       localStorage que ya lee cwear-cart-modal.js (renderizado global,
       su restauración corre en cada carga de página) — no hace falta
       duplicar esa lógica acá. */
    function handleBuyNow() {
      var variant = resolveVariantOrError();
      if (!variant || !buyNowBtn) return;

      buyNowBtn.disabled = true;

      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var backup = cart.items
            .filter(function (item) { return String(item.variant_id) !== String(variant.id); })
            .map(function (item) { return { id: item.variant_id, quantity: item.quantity }; });

          try {
            if (backup.length) {
              localStorage.setItem('cwearCartBackup', JSON.stringify(backup));
            } else {
              localStorage.removeItem('cwearCartBackup');
            }
          } catch (e) { /* noop */ }

          return fetch('/cart/clear.js', { method: 'POST' });
        })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.warn('[cwear-featured-product] buy now error:', err);
          showActionError('No se pudo procesar, intentá de nuevo');
          buyNowBtn.disabled = false;
        });
    }

    if (buyNowBtn) buyNowBtn.addEventListener('click', handleBuyNow);
    if (addToCartBtn) addToCartBtn.addEventListener('click', handleAddToCart);

    if (!optionsWrap) return;

    function formatMoney(cents, format) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = withThousands + '.' + parts[1];
      if (format && format.indexOf('{{amount}}') > -1) {
        return format.replace('{{amount}}', formatted);
      }
      return '$' + formatted;
    }

    /* ── Inicializar selección actual desde los botones ya marcados is-active ── */
    var activeButtons = optionsWrap.querySelectorAll('.is-active');
    Array.prototype.forEach.call(activeButtons, function (btn) {
      var optionIdx = btn.getAttribute('data-option-index');
      var optionName = config.optionNames && config.optionNames[optionIdx];
      if (optionName) {
        currentSelections[optionName] = btn.getAttribute('data-value');
      }
    });

    function findVariant(selections) {
      var optionNames = config.optionNames || [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < optionNames.length; j++) {
          if (v.options[j] !== selections[optionNames[j]]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateOptionsAvailability(selections) {
      var buttons = optionsWrap.querySelectorAll('[data-option-index]');
      Array.prototype.forEach.call(buttons, function (btn) {
        if (!btn.hasAttribute('data-value')) return;
        var optionIdx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        var optionName = config.optionNames && config.optionNames[optionIdx];
        var testSelections = {};
        for (var key in selections) {
          if (Object.prototype.hasOwnProperty.call(selections, key)) {
            testSelections[key] = selections[key];
          }
        }
        testSelections[optionName] = value;
        var matchExists = findVariant(testSelections) !== null;
        if (matchExists) {
          btn.classList.remove('is-unavailable');
          btn.removeAttribute('aria-disabled');
        } else {
          btn.classList.add('is-unavailable');
        }
      });
    }

    function updatePrice(variant) {
      if (!variant || !priceEl) return;
      priceEl.textContent = formatMoney(variant.price, config.moneyFormat);
    }

    /* Solo cambia la imagen si esta variante tiene una propia y es
       distinta de la actual — mismo criterio que el PDP. */
    function updateImage(variant) {
      if (!variant || !variant.featured_image || !imageEl) return;
      var newSrc = variant.featured_image.src;
      if (!newSrc || imageEl.getAttribute('data-fp-image-src') === newSrc) return;
      imageEl.setAttribute('data-fp-image-src', newSrc);
      imageEl.src = newSrc;
      if (imageEl.srcset) imageEl.srcset = '';
      if (mobileSourceEl) mobileSourceEl.srcset = newSrc;
    }

    function onOptionClick(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var group = btn.closest('.cwear-featured-product__option-group');
      var optionIdx = btn.getAttribute('data-option-index');
      var optionName = config.optionNames && config.optionNames[optionIdx];
      if (!optionName) return;

      currentSelections[optionName] = btn.getAttribute('data-value');

      if (group) {
        var siblings = group.querySelectorAll('[data-value]');
        Array.prototype.forEach.call(siblings, function (sib) {
          sib.classList.remove('is-active');
          sib.removeAttribute('aria-pressed');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        var selectedLabel = group.querySelector('.cwear-featured-product__option-selected');
        if (selectedLabel) {
          var displayValue = btn.getAttribute('data-display-value') || btn.getAttribute('data-value');
          selectedLabel.textContent = displayValue;
        }
      }

      updateOptionsAvailability(currentSelections);

      var variant = findVariant(currentSelections);
      updatePrice(variant);
      updateImage(variant);
      showActionError('');
    }

    optionsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-value]');
      if (!btn) return;
      onOptionClick(btn);
    });

    /* ── Carrusel de tallas/colores: flechas + auto-scroll a la activa ── */
    var carousels = optionsWrap.querySelectorAll('.cwear-featured-product__sizes-carousel');
    Array.prototype.forEach.call(carousels, function (carousel) {
      var track = carousel.querySelector('.cwear-featured-product__sizes-track');
      var prevBtn = carousel.querySelector('.cwear-featured-product__sizes-arrow--prev');
      var nextBtn = carousel.querySelector('.cwear-featured-product__sizes-arrow--next');
      if (!track) return;

      function updateCarouselState() {
        var overflows = track.scrollWidth > track.clientWidth + 2;
        if (overflows) {
          carousel.classList.add('has-overflow');
        } else {
          carousel.classList.remove('has-overflow');
        }
        if (prevBtn) {
          prevBtn.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
        }
        if (nextBtn) {
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }

      function scrollTrack(direction) {
        var amount = Math.round(track.clientWidth * 0.75);
        scrollElementByX(track, direction * amount);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollTrack(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollTrack(1); });

      track.addEventListener('scroll', updateCarouselState, { passive: true });

      var activeBtn = track.querySelector('.is-active');
      if (activeBtn) scrollActiveIntoTrack(track, activeBtn);

      updateCarouselState();

      if (typeof window.ResizeObserver === 'function') {
        var ro = new ResizeObserver(function () {
          updateCarouselState();
        });
        ro.observe(track);
      }
    });
  });
})();
